import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import ArrowLineRight from '@icons/arrow/ArrowLineRight';
import { useFlow } from '@stackflow/react';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import useNearShop from './hooks/useNearShop';

function NearBy() {
    const shop = useNearShop();
    const { push } = useFlow();
    const { t } = useTranslation('main');
    if (shop) {
        const {
            thumbnailImageUrl, name, address, id,
        } = shop;
        return (
            <Container id='nearby-shop'
                data-shop-id={id}
                data-shop-name={name} >
                <Text size='title' fontWeight='bold'>
                    {t('nearBy.title')}
                </Text>
                <Content spacing={3} align='center'
                    onClick={() => push('ItemsActivity', { shopId: id, type: 'ALL' })} >
                    <Thumbnail src={thumbnailImageUrl}
                        width={48}
                        height={48} />
                    <TextContainer spacing={1}>
                        <Text size='title' fontWeight='medium' ellipsis>
                            {name}
                        </Text>
                        <Text color={colors.textSecondary}
                            size='body-long'
                            ellipsis>{address}</Text>
                    </TextContainer>
                    <ArrowLineRight size={16} />
                </Content>
            </Container>
        );
    }
    return null;
}

const Container = styled.div`
    padding: 0 var(--spacing-4);
    margin-bottom: var(--spacing-12);
    display: flex;
    flex-direction: column;
    row-gap: 16px;
    width: 100%;
`;

const Content = styled(Row)`
    padding: var(--spacing-4);
    background-color: var(--color-background-pure);
    border-radius: var(--radius-sm);
`;

const Thumbnail = styled(Image)`
    border-radius: var(--radius-sm);
    flex-shrink: 0;
    object-fit: cover;
`;

const TextContainer = styled(Column)`
    flex: 1;
    overflow: hidden;
`;

export default NearBy;
